import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { Observable, of } from 'rxjs';
import { PageBaseComponent } from '../../abstracts/page-base/page-base.component';
import { Session } from '../../models/session';
import { ApiService } from '../../services/api.service';
import { Parameters } from '../../utilities/parameters';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-sessions',
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    ProgressSpinnerModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    DialogModule,
    TabsModule,
    SelectModule,
    DatePickerModule
  ],
  providers: [MessageService],
  templateUrl: './sessions.component.html',
  styles: ``
})
export class SessionsComponent extends PageBaseComponent<Session> {
  items: Session[] = [];

  organizationOptions: { id: number; value: string }[] = [];
  selectedOrganization: { id: number; value: string } = { id: 0, value: '' };

  teamOptions: { id: number; value: string }[] = [];
  selectedTeam: { id: number; value: string } = { id: 0, value: '' };

  constructor(apiService: ApiService, messageService: MessageService, private route: ActivatedRoute, private router: Router) {
    super(apiService, messageService)
  }

  onNavigate(session: Session): void {
    this.router.navigate(['session'], {
      relativeTo: this.route,
      state: { orgId: session.organizationId, teamId: session.teamId, sesId: session.sessionId }
    })
  }

  onOrganizationSelected(event: any): void {
    this.selectedItem.organizationId = this.selectedOrganization.id;

    this.apiService.getOrganizationTeams(this.selectedOrganization.id).subscribe({
      next: (data) => {
        this.teamOptions = data.map(t => ({
          id: t.teamId,
          value: t.name
        }));

        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.showError(err);
      }
    });
  }

  override onSave(): void {
    if (this.isNew) {
      this.selectedItem.organizationId = this.selectedOrganization.id;
      this.selectedItem.teamId = this.selectedTeam.id;

      this.apiService.addSession(this.selectedItem).subscribe({
        next: () => {
          this.showDialog = false;
          this.showSuccess("La sessione è stata salvata correttamente");
          this.resetItems();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err);
        },
        complete: () => {
          this.loadData();
        }
      });
    }
  }

  onTeamSelected(event: any): void {
    this.selectedItem.teamId = this.selectedTeam.id;
  }

  protected override loadData(): void {
    this.loading = true;

    this.apiService.getSessions().subscribe({
      next: (data) => {
        this.items = data;
        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.showError(err);
      },
      complete: () => {
        this.loading = false;
      }
    })

    if ({ ...Parameters.loggedUser }.role == 1) {
      // superAdmin deve poter vedere tutte le organizzazioni
      this.apiService.getOrganizations().subscribe({
        next: (data) => {
          this.organizationOptions = data.map(org => ({
            id: org.organizationId,
            value: org.name
          }));

          this.dtTrigger.next(true);
        },
        error: (err: HttpErrorResponse) => {
          this.loading = false;
          this.showError(err);
        },
        complete: () => {
          this.loading = false;
        }
      })
    }
    else if ({ ...Parameters.loggedUser }.role < 4) {
      this.organizationOptions = { ...Parameters.loggedUser }.organizations.map(org => ({
        id: org.organizationId,
        value: org.name
      }));
    }
  }

  protected override loadSelectedInfo(): Observable<boolean> {
    this.isNew = this.selectedItem.teamId === 0;

    return of(true);
  }

  protected override resetItems(): void {
    this.newItem = {
      organizationId: 0,
      teamId: 0,
      sessionId: 0,
      name: '',
      description: '',
      date: new Date(),
      organization: '',
      team: ''
    };

    this.selectedItem = {
      organizationId: 0,
      teamId: 0,
      sessionId: 0,
      name: '',
      description: '',
      date: new Date(),
      organization: '',
      team: ''
    };

    this.selectedOrganization = { id: 0, value: '' };
    this.selectedTeam = { id: 0, value: '' };
  }
}
